// Иконка приложения (та же, что в manifest.json) — узнаваемая картинка по
// умолчанию, когда более подходящей для конкретного действия нет
export const DEFAULT_SHARE_IMAGE_URL = '/img/app-icon/icon-512.47dd28ee.png';

const loadImageFile = async (imageUrl) => {
  try {
    const response = await fetch(imageUrl);
    if (!response.ok) {
      return null;
    }
    const blob = await response.blob();
    if (!blob.type.startsWith('image/')) {
      // Дев-сервер на несуществующий путь отдает index.html со статусом 200 —
      // такой «файл» в панель «Поделиться» отправлять нельзя
      return null;
    }
    const fileName = imageUrl.split('/').pop() || 'strategikon.png';
    return new File([blob], fileName, {type: blob.type});
  } catch (e) {
    console.error('Share image load failed', imageUrl, e);
    return null;
  }
};

/**
 * Картинка для Web Share API (уровень 2, поле files).
 *
 * Сначала пробуется переданная картинка (например, сундук из наград), при
 * неудаче — картинка по умолчанию. Возвращает null, если не вышло ничего:
 * вызов «поделиться» в этом случае должен уйти без вложения, а не падать.
 *
 * @param {string} [preferredImageUrl] - желаемая картинка
 * @returns {Promise<File|null>}
 */
export const getShareImageFile = async (preferredImageUrl) => {
  if (typeof File !== 'function') {
    return null;
  }

  if (preferredImageUrl && preferredImageUrl !== DEFAULT_SHARE_IMAGE_URL) {
    const preferredFile = await loadImageFile(preferredImageUrl);
    if (preferredFile) {
      return preferredFile;
    }
  }

  return loadImageFile(DEFAULT_SHARE_IMAGE_URL);
};
